module.exports = __webpack_public_path__ + "img/GAME_BLOCKFLIP.0a1a5a95.png";